import {
    FETCH_SUPPLIER_INCOME_REQUEST,
    FETCH_SUPPLIER_INCOME_SUCCESS,
    FETCH_SUPPLIER_INCOME_FAILURE,
  } from "./FetchSuppliesIncomeTypes";
  
  const initialState = {
    loading: false,
    supplierIncome: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SUPPLIER_INCOME_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_SUPPLIER_INCOME_SUCCESS:
        return {
          loading: false,
          supplierIncome: action.payload,
          error: "",
        };
      case FETCH_SUPPLIER_INCOME_FAILURE:
        return {
          loading: false,
          supplierIncome: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  